import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PageComponent } from '@app/v2/components/page/page.component';
import { StudiesComponent } from '@app/v2/components/studies/studies.component';

@Component({
    selector: 'medpace-studies.page',
    imports: [PageComponent, StudiesComponent],
    templateUrl: './studies.page.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StudiesPageComponent {}
